module.exports = __webpack_public_path__ + "img/logo-waberers.172653d.png";